// Mobile menu
document.addEventListener('click', e => {
  if (e.target.closest('.menu-toggle')) {
    document.querySelector('.nav')?.classList.toggle('open');
  }
});

// Reveal on scroll
const io = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
}, { threshold: 0.12 });
document.querySelectorAll('.reveal').forEach(el => io.observe(el));

// Email popup (10s or exit-intent, once per session)
(function() {
  if (sessionStorage.getItem('ig_popup_seen')) return;
  const p = document.querySelector('.popup-overlay');
  if (!p) return;
  let shown = false;
  const show = () => {
    if (shown) return; shown = true;
    sessionStorage.setItem('ig_popup_seen', '1');
    p.classList.add('show');
  };
  setTimeout(show, 10000);
  document.addEventListener('mouseout', e => { if (!e.relatedTarget && e.clientY < 10) show(); });
  p.addEventListener('click', e => {
    if (e.target === p || e.target.closest('.popup-close')) p.classList.remove('show');
  });
  p.querySelector('form')?.addEventListener('submit', e => {
    e.preventDefault();
    p.querySelector('.popup').innerHTML = '<h3>Danke!</h3><p>Dein Rabattcode ist unterwegs. Schau in dein Postfach.</p>';
    setTimeout(() => p.classList.remove('show'), 2500);
  });
})();

// Qty stepper
document.addEventListener('click', e => {
  const btn = e.target.closest('[data-qty]');
  if (!btn) return;
  const input = btn.parentElement.querySelector('input');
  let v = parseInt(input.value || '1', 10);
  v = btn.dataset.qty === '+' ? v + 1 : Math.max(1, v - 1);
  input.value = v;
});

// Gallery thumbnails
(function() {
  const mainImage = document.getElementById('mainProductImage');
  const thumbs = document.querySelectorAll('.thumb-wrap');
  if (!mainImage || !thumbs.length) return;
  thumbs.forEach(wrap => {
    wrap.addEventListener('click', () => {
      const img = wrap.querySelector('.gallery-thumb');
      if (img && img.dataset.full) {
        mainImage.src = img.dataset.full;
        thumbs.forEach(t => t.classList.remove('active'));
        wrap.classList.add('active');
      }
    });
  });
})();

// Variant selector
(function() {
  const cards = document.querySelectorAll('.variant-card');
  if (!cards.length) return;
  const idInput = document.getElementById('variantId');
  const priceEl = document.getElementById('currentPrice');
  const compareEl = document.getElementById('comparePrice');
  const savingsEl = document.getElementById('priceSavings');
  const stickyPrice = document.getElementById('stickyPrice');
  const mainImage = document.getElementById('mainProductImage');
  const thumbs = document.querySelectorAll('.thumb-wrap');

  cards.forEach(card => {
    if (card.disabled) return;
    card.addEventListener('click', () => {
      cards.forEach(c => c.classList.remove('active'));
      card.classList.add('active');
      if (idInput) idInput.value = card.dataset.variantId;
      if (priceEl) priceEl.textContent = card.dataset.price;
      // Streichpreis nur zeigen, wenn er echt hoeher ist als der Verkaufspreis
      if (compareEl) {
        var pR = parseInt(card.dataset.priceRaw || '0', 10);
        var cR = parseInt(card.dataset.compareRaw || '0', 10);
        if (cR > pR) {
          compareEl.textContent = card.dataset.compare;
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }
      if (stickyPrice) stickyPrice.textContent = card.dataset.price;

      // Variantenbild wechseln + passenden Thumbnail aktivieren
      if (mainImage && card.dataset.variantImage) {
        mainImage.src = card.dataset.variantImage;
        if (card.dataset.variantImageId && thumbs.length) {
          thumbs.forEach(t => {
            t.classList.toggle('active', t.dataset.imageId === card.dataset.variantImageId);
          });
        }
      }

      // Calculate savings + dynamic badge
      const priceRaw = parseInt(card.dataset.priceRaw || '0', 10);
      const compareRaw = parseInt(card.dataset.compareRaw || '0', 10);
      const badgeEl = document.getElementById('discountBadge');
      if (compareRaw > priceRaw) {
        const saveCents = compareRaw - priceRaw;
        const saveEur = (saveCents / 100).toFixed(2).replace('.', ',');
        const pct = Math.round((saveCents / compareRaw) * 100);
        if (savingsEl) savingsEl.textContent = 'Du sparst ' + saveEur + ' € (' + pct + '%)';
        if (badgeEl) { badgeEl.textContent = '-' + pct + '%'; badgeEl.style.display = ''; }
      } else {
        if (savingsEl) savingsEl.textContent = '';
        if (badgeEl) badgeEl.style.display = 'none';
      }
    });
  });
})();

// Cart drawer + AJAX-Warenkorb
(function() {
  const overlay = document.getElementById('cartOverlay');
  const drawer = document.getElementById('cartDrawer');
  const closeBtn = document.getElementById('cartDrawerClose');
  if (!drawer) return;

  const body = document.getElementById('cartDrawerBody');
  const FREE_SHIP = 5000; // Cent – Schwelle für Gratisversand
  const money = c => (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

  const openDrawer = () => { overlay?.classList.add('open'); drawer.classList.add('open'); document.body.style.overflow = 'hidden'; };
  const closeDrawer = () => { overlay?.classList.remove('open'); drawer.classList.remove('open'); document.body.style.overflow = ''; };

  function updateCount(n) {
    const c = document.getElementById('cartDrawerCount');
    if (c) c.textContent = n;
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  function renderBody(cart) {
    updateCount(cart.item_count);
    if (!body) return;

    let progress = '<div class="cart-drawer-progress"><div class="progress-text" style="color:var(--success)">✅ Kostenloser Versand inklusive</div></div>';

    if (cart.item_count === 0) {
      body.innerHTML = progress +
        '<div class="cart-drawer-items"><div style="text-align:center;padding:3rem 1rem;color:var(--muted)">' +
        '<p style="font-size:2rem;margin-bottom:.5rem">🛒</p><p>Dein Warenkorb ist leer</p>' +
        '<a href="/products/irongrip" class="btn btn-secondary" style="margin-top:1rem">Zum IRONGRIP →</a></div></div>';
      return;
    }

    let items = '';
    cart.items.forEach(item => {
      const img = item.image ? '<img src="' + item.image + '" alt="" width="60" height="60" style="border-radius:var(--radius);background:var(--bg-3)">' : '';
      const variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="muted" style="font-size:.8rem">' + item.variant_title + '</p>' : '';
      items +=
        '<div class="cart-drawer-item" data-key="' + item.key + '">' + img +
          '<div class="cart-drawer-item-info">' +
            '<strong style="font-size:.9rem">' + item.product_title + '</strong>' + variant +
            '<div class="cart-drawer-qty">' +
              '<button type="button" class="cd-qty" data-key="' + item.key + '" data-dir="-" aria-label="Weniger">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" class="cd-qty" data-key="' + item.key + '" data-dir="+" aria-label="Mehr">+</button>' +
              '<button type="button" class="cd-remove" data-key="' + item.key + '" aria-label="Entfernen">Entfernen</button>' +
            '</div>' +
            '<p style="font-size:.9rem;margin-top:.25rem">' + money(item.final_line_price) + '</p>' +
          '</div>' +
        '</div>';
    });

    const footer =
      '<div class="cart-drawer-footer">' +
        '<div class="cart-drawer-trust"><span>🔒 Sichere Zahlung</span><span>🔄 14 Tage Rückgabe</span><span>📦 Tracking inklusive</span></div>' +
        '<div class="cart-drawer-total"><span>Zwischensumme</span><span class="price-now" style="font-size:1.5rem">' + money(cart.total_price) + '</span></div>' +
        '<a href="/checkout" class="btn btn-primary btn-block btn-lg">Zur Kasse — ' + money(cart.total_price) + '</a>' +
      '</div>';

    body.innerHTML = progress + '<div class="cart-drawer-items">' + items + '</div>' + footer;
  }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      renderBody(await res.json());
    } catch (e) {}
  }

  async function changeLine(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      renderBody(await res.json());
    } catch (e) {}
  }

  // Menge ändern / entfernen (Delegation)
  drawer.addEventListener('click', e => {
    const qtyBtn = e.target.closest('.cd-qty');
    const rmBtn = e.target.closest('.cd-remove');
    if (qtyBtn) {
      const line = qtyBtn.closest('.cart-drawer-item');
      const cur = parseInt(line.querySelector('.cart-drawer-qty span').textContent, 10) || 1;
      changeLine(qtyBtn.dataset.key, Math.max(0, qtyBtn.dataset.dir === '+' ? cur + 1 : cur - 1));
    } else if (rmBtn) {
      changeLine(rmBtn.dataset.key, 0);
    }
  });

  // Warenkorb-Icon öffnet Drawer mit frischem Inhalt
  document.querySelectorAll('.cart-link').forEach(link => {
    link.addEventListener('click', e => { e.preventDefault(); openDrawer(); refreshCart(); });
  });

  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // "In den Warenkorb" per AJAX statt Seitenwechsel
  const form = document.getElementById('addToCartForm');
  if (form) {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = document.getElementById('addToCartBtn');
      const label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        if (!res.ok) throw new Error('add failed');
        await refreshCart();
        openDrawer();
      } catch (err) {
        window.location.href = '/cart'; // Fallback, falls etwas schiefgeht
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = label || 'In den Warenkorb'; }
      }
    });
  }
})();

// Sticky CTA visibility (show only when add-to-cart is out of view)
(function() {
  const sticky = document.getElementById('stickyCta');
  const form = document.getElementById('addToCartForm');
  if (!sticky || !form) return;
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      sticky.style.display = e.isIntersecting ? 'none' : 'flex';
    });
  }, { threshold: 0 });
  obs.observe(form);
})();

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
});
